import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10,
	height: 10,
	fill: "none",
	viewBox: "0 0 10 10",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M2.4 0c.56 0 .84 0 1.054.11a1 1 0 0 1 .437.436C4 .76 4 1.04 4 1.6v6.8c0 .56 0 .84-.11 1.054a1 1 0 0 1-.436.437C3.24 10 2.96 10 2.4 10h-.8c-.56 0-.84 0-1.054-.11a1 1 0 0 1-.437-.436C0 9.24 0 8.96 0 8.4V1.6C0 1.04 0 .76.11.546A1 1 0 0 1 .545.109C.76 0 1.04 0 1.6 0zm6 0c.56 0 .84 0 1.054.11a1 1 0 0 1 .437.436C10 .76 10 1.04 10 1.6v6.8c0 .56 0 .84-.11 1.054a1 1 0 0 1-.436.437C9.24 10 8.96 10 8.4 10h-.8c-.56 0-.84 0-1.054-.11a1 1 0 0 1-.437-.436C6 9.24 6 8.96 6 8.4V1.6c0-.56 0-.84.11-1.054a1 1 0 0 1 .436-.437C6.76 0 7.04 0 7.6 0z"
	})
});
export default SvgPause;
